import {
  IconBasketAdd,
  IconGift,
  IconPen,
  IconPlusRounded,
  IconTrash,
  // IconUpload,
} from "@aksara-ui/icons";
import {
  TableHeadRow,
  Box,
  Button,
  Card,
  Stack,
  Table,
  TableHead,
  Text,
  TableHeadCell,
  TableBody,
  TableBodyRow,
  TableBodyCell,
  Badge,
  IconButton,
  theme,
} from "@aksara-ui/react";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import {
  getAllTenantsFilter,
  getAllVouchers,
  setModalConfirmationOpen,
  setModalDescriptionOpen,
  setModalFormOpen,
} from "redux/actions";
import styled from "styled-components";
import {
  VoucherFormModal,
  VoucherConfirmationModal,
  // VoucherReleaseModal,
  VoucherDescriptionFormModal,
} from "./components";
import moment from "moment";
import {
  Pagination,
  PaginationDetail,
  PaginationFilter,
} from "components/Pagination";
import { CatalogStocksContent } from "modules/Catalogs/CatalogStocks";
import { InputSearchbox } from "components/Form/InputSearchbox";
import FilterKit from "components/FilterKit";
import { getRole } from "hooks";
import LazyLoadImageWithBlurHash from "components/LazyLoadImageWithBlurHash";
import { Link } from "react-router-dom";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 20px;
`;

const VouchersContent: React.FC = () => {
  const dispatch = useDispatch();
  const userRole = getRole();
  const isMobile = useMediaQuery({ maxWidth: 576 });
  const isTablet = useMediaQuery({ maxWidth: 1024 });

  const {
    appUrl,
    isLoading,
    isModalFormOpen,
    isModalConfirmationOpen,
    isModalDescriptionOpen,
  } = useSelector((state: any) => state.globalReducer);
  const { vouchers } = useSelector((state: any) => state.voucherReducer);
  const { currentPage, totalPage, limitPage, lengthPage, filterTenantPage } =
    useSelector((state: any) => state.voucherReducer);
  const { tenantsFilter } = useSelector((state: any) => state.tenantReducer);

  const [searchValue, setSearchValue] = useState("");
  const [limit, setLimit] = useState(10);
  const [selectedVoucherId, setSelectedVoucherId] = useState("");
  const [modalVoucherStocksOpen, setModalVoucherStocksOpen] = useState(false);
  // const [modalReleaseVoucherOpen, setModalReleaseVoucherOpen] = useState(false);

  const handleSearchChange = (event: any) => {
    setSearchValue(event.target.value);
    dispatch(
      getAllVouchers(1, event.target.value, limitPage, filterTenantPage) as any
    );
  };

  const handleClearSearchChange = () => {
    setSearchValue("");
    dispatch(
      getAllVouchers(currentPage, "", limitPage, filterTenantPage) as any
    );
  };

  const handleOpenFormModal = (voucherId: string = "") => {
    dispatch(setModalFormOpen(true) as any);
    setSelectedVoucherId(voucherId);
  };

  const handleCloseFormModal = () => {
    dispatch(setModalFormOpen(false) as any);
    setSelectedVoucherId("");
  };

  const handleOpenConfirmModal = (voucherId: string) => {
    dispatch(setModalConfirmationOpen(true) as any);
    setSelectedVoucherId(voucherId);
  };

  const handleCloseConfirmModal = () => {
    dispatch(setModalConfirmationOpen(false) as any);
    setSelectedVoucherId("");
  };

  const handleOpenVoucherStocksModal = (voucherId: string) => {
    setModalVoucherStocksOpen(true);
    setSelectedVoucherId(voucherId);
  };

  const handleCloseVoucherStocksModal = () => {
    setModalVoucherStocksOpen(false);
    setSelectedVoucherId("");
  };

  
  const handleOpenVoucherDescriptionFormModal = (catalogId: string) => {
    dispatch(setModalDescriptionOpen(true) as any);
    setSelectedVoucherId(catalogId);
  };

  const handleCloseVoucherDescriptionFormModal = () => {
    dispatch(setModalDescriptionOpen(false) as any);
    setSelectedVoucherId("");
  };

  // const handleOpenReleaseVoucherModal = (voucherId: string) => {
  //   setModalReleaseVoucherOpen(true);
  //   setSelectedVoucherId(voucherId);
  // };

  // const handleCloseReleaseVoucherModal = () => {
  //   setModalReleaseVoucherOpen(false);
  //   setSelectedVoucherId("");
  // };

  useEffect(() => {
    dispatch(getAllTenantsFilter() as any);
    dispatch(getAllVouchers() as any);
  }, [dispatch]);

  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <HeaderWrapper
        display={"flex"}
        flexDirection={"column"}
        style={{ gap: 20 }}
      >
        <Box display={"flex"}>
          <Text scale={[500, 600]} fontWeight={700}>
            Digital Goods
          </Text>
        </Box>

        <Box
          display={"flex"}
          flexDirection={isMobile ? "column" : "row"}
          justifyContent={"space-between"}
          style={{ gap: isMobile ? 10 : 20 }}
        >
          <Box
            display={"flex"}
            flexDirection={isTablet ? "column" : "row"}
            justifyContent={"space-between"}
            style={{ gap: 5 }}
          >
            <InputSearchbox
              autoComplete="off"
              name="textDummy"
              placeholder="Search..."
              size={32}
              onChange={handleSearchChange}
              onClearButton={handleClearSearchChange}
            />

            {userRole === "superadmin" ? (
              <FilterKit
                orderByOptions={[
                  {
                    key: tenantsFilter,
                    label: "Tenant",
                    options: tenantsFilter.map((tenant: any) => {
                      return {
                        label: tenant.name,
                        value: tenant.id,
                      };
                    }),
                  },
                ]}
                onChangeOrder={(e: any) => {
                  dispatch(
                    getAllVouchers(
                      1,
                      "",
                      limitPage,
                      e[tenantsFilter] ? e[tenantsFilter].value : ""
                    ) as any
                  );
                }}
              />
            ) : (
              <></>
            )}
          </Box>
          <Stack
            display={"flex"}
            justifyContent={"right"}
            flexDirection={"row"}
            style={{ gap: isMobile ? 10 : 20 }}
          >
            <Button
              variant="primary"
              borderRadius={10}
              style={{ fontWeight: 600 }}
              icon={IconPlusRounded}
              iconPosition={"left"}
              size={32}
              onClick={() => handleOpenFormModal()}
            >
              Add Voucher
            </Button>
          </Stack>
        </Box>
      </HeaderWrapper>

      <Card overflow={"auto"} elevation={2} maxHeight={"100%"}>
        <Table>
          <TableHead
            position={"sticky"}
            top={0}
            backgroundColor={theme.colors.grey02}
          >
            <TableHeadRow>
              <TableHeadCell>Voucher Name</TableHeadCell>
              <TableHeadCell minWidth={150}>Image</TableHeadCell>
              <TableHeadCell>Merchant</TableHeadCell>
              <TableHeadCell>Points Needed</TableHeadCell>
              <TableHeadCell>Available Stock</TableHeadCell>
              <TableHeadCell>Expiry Date</TableHeadCell>
              {/* <TableHeadCell>Release Voucher</TableHeadCell> */}
              <TableHeadCell>Push Reward</TableHeadCell>
              <TableHeadCell>Action</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={7} />
            ) : !vouchers.length ? (
              <TableBodyRow>
                <TableBodyCell colSpan={7} textAlign={"center"}>
                  No data available in table
                </TableBodyCell>
              </TableBodyRow>
            ) : (
              vouchers.map((voucher: any) => {
                return (
                  <TableBodyRow key={voucher.id}>
                    <TableBodyCell
                      onClick={() =>
                        handleOpenVoucherDescriptionFormModal(voucher.id)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {voucher.catalog_name}
                    </TableBodyCell>
                    <TableBodyCell
                      onClick={() =>
                        handleOpenVoucherDescriptionFormModal(voucher.id)
                      }
                      style={{ cursor: "pointer", height: 150, width: 140 }}
                    >
                      {voucher.img_url ? (
                        <LazyLoadImageWithBlurHash
                          key={voucher.id}
                          src={`${appUrl}/storage/${voucher.img_url}`}
                          blurHash="LEHV6nWB2yk8pyo0adR*.7kCMdnj"
                          alt="voucher-image"
                          height={"auto"}
                          width={140}
                          style={{
                            borderRadius: 10,
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </TableBodyCell>
                    <TableBodyCell
                      onClick={() =>
                        handleOpenVoucherDescriptionFormModal(voucher.id)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <Badge size="md" variant="default">
                        {voucher.catalog_product}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell
                      whiteSpace={"nowrap"}
                      onClick={() =>
                        handleOpenVoucherDescriptionFormModal(voucher.id)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <Badge size="md" variant="info">
                        {voucher.points_needed.toLocaleString()} Pts
                      </Badge>
                    </TableBodyCell>
                         <TableBodyCell
                      whiteSpace={"nowrap"}
                      onClick={() =>
                        handleOpenVoucherDescriptionFormModal(voucher.id)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <Badge size="md" variant="info">
                        {voucher.available_stock.toLocaleString()}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell
                      onClick={() =>
                        handleOpenVoucherDescriptionFormModal(voucher.id)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {moment(voucher.expiry_date).format("DD MMM YYYY")}
                    </TableBodyCell>
                    {/* <TableBodyCell whiteSpace={"nowrap"}>
                      <Button
                        variant="primary"
                        borderRadius={50}
                        size={32}
                        style={{ fontWeight: 600 }}
                        icon={IconUpload}
                        iconPosition={"left"}
                        onClick={() =>
                          handleOpenReleaseVoucherModal(voucher.id)
                        }
                      >
                        Release
                      </Button>
                    </TableBodyCell> */}
                    <TableBodyCell whiteSpace={"nowrap"} textAlign={"center"}>
                      <Link to={`/products/gifts/${voucher.id}`}>
                        <IconButton
                          borderRadius={50}
                          size={32}
                          style={{
                            fontWeight: 600,
                            backgroundColor: theme.colors.blue06,
                          }}
                          type={"button"}
                        >
                          <IconGift fill={"white"} />
                        </IconButton>
                      </Link>
                    </TableBodyCell>
                    <TableBodyCell>
                      <IconButton
                        onClick={() => handleOpenVoucherStocksModal(voucher.id)}
                      >
                        <IconBasketAdd fill={theme.colors.blue06} />
                      </IconButton>
                      <IconButton
                        onClick={() => handleOpenFormModal(voucher.id)}
                      >
                        <IconPen fill={theme.colors.green06} />
                      </IconButton>
                      <IconButton
                        onClick={() => handleOpenConfirmModal(voucher.id)}
                      >
                        <IconTrash fill={theme.colors.red06} />
                      </IconButton>
                    </TableBodyCell>
                  </TableBodyRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Card>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingY={10}
      >
        {!isMobile ? (
          <PaginationDetail
            page={currentPage}
            limit={limitPage}
            length={lengthPage}
          />
        ) : (
          ""
        )}
        <Pagination
          current={currentPage}
          total={totalPage}
          onSelect={(select: any) =>
            dispatch(
              getAllVouchers(
                select,
                searchValue,
                limitPage,
                filterTenantPage
              ) as any
            )
          }
        />
        <PaginationFilter
          selectedItem={limit}
          onChange={(selectedItem) => {
            if (selectedItem) {
              setLimit(selectedItem);
              dispatch(
                getAllVouchers(
                  1,
                  searchValue,
                  selectedItem,
                  filterTenantPage
                ) as any
              );
            }
          }}
          items={[10, 20, 30, 40, 50]}
        />
      </Box>

      <VoucherFormModal
        voucherId={selectedVoucherId}
        isOpen={isModalFormOpen}
        onClose={() => handleCloseFormModal()}
      />

      <VoucherConfirmationModal
        voucherId={selectedVoucherId}
        isOpen={isModalConfirmationOpen}
        onClose={() => handleCloseConfirmModal()}
      />

      <CatalogStocksContent
        catalogId={selectedVoucherId}
        type={"Voucher"}
        isOpen={modalVoucherStocksOpen}
        onClose={() => handleCloseVoucherStocksModal()}
      />

      <VoucherDescriptionFormModal
        voucherId={selectedVoucherId}
        isOpen={isModalDescriptionOpen}
        onClose={() => handleCloseVoucherDescriptionFormModal()}
      />

      {/* <VoucherReleaseModal
        voucherId={selectedVoucherId}
        isOpen={modalReleaseVoucherOpen}
        onClose={() => handleCloseReleaseVoucherModal()}
      /> */}
    </Box>
  );
};

export default VouchersContent;
